import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/pages/Home.vue'
import Article from '@/pages/Article.vue'

import KeyView from '@/pages/KeyView.vue'
import JoinUs from '@/pages/JoinUs.vue'

import About from '@/pages/About.vue'

import Default from '@/pages/Default.vue'
// import Missing from '@/pages/Missing.vue'

// import Log from '../views/Log.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    // name: 'Home',
    component: Home,
    children: [
      {
        path: '/',
        name: 'KeyView',
        component: KeyView
      },
      {
        path: '/joinus',
        name: 'JoinUs',
        component: JoinUs
      },
      {
        path: '/services',
        name: 'About',
        component: About
      }
    ]
  },
  {
    path: '/article/:articleId',
    name: 'Article',
    component: Article
  },
  {
    path: '*',
    name: 'Default',
    component: Default
  }
  // {
  //   path: '/CreatorProject',
  //   name: 'CreatorProject',
  //   component: CreatorProject
  // }

]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
